import LabServiceModel from "@/models/LabServiceModel";

export default class JigModel extends LabServiceModel {
  modelName() {
    return 'jig';
  }
  defaults() {
    return {
      id: null,
      name: null,
      x: null,
      y: null,
      z: null,
      capacity: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      x: Number,
      y: Number,
      z: Number,
      capacity: Number,
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }
  validation() {
    return {}
  }
}
